export default [
  {
    path: '/komform-dashboard',
    name: 'komform-dashboard',
    component: () => import('@/views/pages/komform/dashboard/Dashboard.vue'),
    meta: {
      resource: 'Komform - Dashboard',
      action: 'manage',
    },
  },
]
